import { Formik, type FormikHelpers, type FormikProps } from 'formik';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Child, Container, Subtitle, Title } from '../components';
import { AuthService, useRecaptcha } from '../services';
import { register } from '../text';
import type { IRegisterFormValues } from '../types';
import { RegisterForm, registerSchema } from './register/RegisterForm';

export const Register = () => {
	const initialValues: IRegisterFormValues = {
		companyName: '',
		companyType: '',
		zip: '',
		firstName: '',
		lastName: '',
		email: '',
		confirmEmail: '',
	};
	const navigate = useNavigate();
	const { recaptchaToken } = useRecaptcha();
	const [tokenV2, setTokenV2] = useState('');
	return (
		<Container container>
			<Child>
				<Title>{register.title}</Title>
				<Subtitle>{register.subtitle}</Subtitle>
			</Child>
			<Child container>
				<Formik
					initialValues={initialValues}
					validationSchema={registerSchema}
					onSubmit={(v: IRegisterFormValues, a: FormikHelpers<IRegisterFormValues>) => {
						AuthService.register(
							v.email,
							v.zip,
							v.companyName,
							v.companyType,
							v.firstName,
							v.lastName,
							tokenV2,
							recaptchaToken
						).then(
							() =>
								navigate(`/login?ref=/register&request=pin`, {
									state: { email: v.email, token: tokenV2 },
								}),
							err => {
								if (err.status === 409) {
									a.setFieldValue('email', '', false);
									a.setFieldValue('confirmEmail', '', false);
									a.setFieldError('email', 'A user with that email account already exists.');
								} else {
									Promise.reject(err);
								}
							}
						);
					}}
				>
					{(props: FormikProps<IRegisterFormValues>) => (
						<RegisterForm onV2={(token: string) => setTokenV2(token)} {...props} />
					)}
				</Formik>
			</Child>
		</Container>
	);
};
